export default __webpack_public_path__ + "static/media/info.f588700f.svg";